import { createFileRoute, Link } from "@tanstack/react-router";
import { useSuspenseQuery } from "@tanstack/react-query";
import { orpc } from "@/lib/orpc";
import { PlanOfCareScreen } from "./-components/documents/plan-of-care-screen";

export const Route = createFileRoute(
  "/_authenticated/_care/residents/$residentId/plans-of-care/$planId",
)({
  component: PlanOfCareView,
});

function PlanOfCareView() {
  const { residentId, planId } = Route.useParams();
  const { data: resident } = useSuspenseQuery(
    orpc.care.residents.get.queryOptions({ input: { residentId } }),
  );

  return (
    <PlanOfCareScreen
      planId={planId}
      resident={resident}
      back={
        <Link params={{ residentId }} to="/residents/$residentId/physician-poc">
          Back to the chart
        </Link>
      }
      printLabel="Print"
      missingDescription="It may have been removed, or it belongs to another resident. The chart lists every plan on file."
    />
  );
}
